document.addEventListener('DOMContentLoaded', function () {
  const currentTimeElement = document.getElementById('current-time');
  if (currentTimeElement) {
    function updateTime() {
      const now = new Date();
      const formattedDate = now.toLocaleDateString('en-GB').replace(/\//g, '-');
      const options = {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
      };
      const formattedTime = now.toLocaleTimeString('en-GB', options);
      currentTimeElement.textContent = `${formattedDate} ${formattedTime}`;
    }
    updateTime();
    setInterval(updateTime, 60000);
  }
});
